import type { TaskSchedule } from "../api/requests";

export function getNearestNextRunAt(schedules: TaskSchedule[] | undefined): Date | null {
  if (!schedules?.length) return null;

  let nearest: Date | null = null;
  for (const item of schedules) {
    if (item.status && item.status !== "active") continue;
    if (!item.nextRunAt) continue;
    const date = new Date(item.nextRunAt);
    if (Number.isNaN(date.getTime())) continue;
    if (!nearest || date.getTime() < nearest.getTime()) {
      nearest = date;
    }
  }
  return nearest;
}

export function formatScheduleDateTime(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}
